export default "__VITE_ASSET__Bxrh540H__"